import _ from 'lodash';
import Query from '@jgile/laravel-vue/resources/js/lib/Query';

export default class QueryBuilder {
    constructor(model, query = null) {
        this.model = model;
        this.$query = new Query(query);
    }

    set(attributes) {
        this.$query.set(attributes);
        return this;
    }

    url(url = '/') {
        return `${url}?${this.query()}`;
    }

    // query string parsed
    query() {
        return this.$query.toQueryString(this.$query);
    }

    presenter(args) {
        this.$query.presenter = args;
        return this;
    }

    include(...args) {
        this.$query.include = Array.isArray(args[0]) ? args[0] : args;
        return this;
    }

    appends(...args) {
        this.$query.append = Array.isArray(args[0]) ? args[0] : args;
        return this;
    }

    select(...fields) {
        if (fields.length === 0) {
            throw new Error('You must specify the fields on select() method.');
        }

        // single entity .select(['age', 'firstname'])
        if (fields[0].constructor === String || Array.isArray(fields[0])) {
            this.$query.fields[this.model.$resource] = fields.join(',');
        }

        // related entities .select({ posts: ['title', 'content'], user: ['age', 'firstname']} )
        if (fields[0].constructor === Object) {
            Object.entries(fields[0]).forEach(([key, value]) => {
                this.$query.fields[key] = value.join(',');
            });
        }

        return this;
    }

    where(key, value) {
        if (key === undefined || value === undefined) throw new Error('The KEY and VALUE are required on where() method.');

        if (Array.isArray(value) || value instanceof Object) throw new Error('The VALUE must be primitive on where() method.');

        this.$query.filter[key] = value;

        return this;
    }

    whereIn(key, array) {
        if (!Array.isArray(array)) throw new Error('The second argument on whereIn() method must be an array.');

        this.$query.filter[key] = array.join(',');

        return this;
    }

    orderBy(...args) {
        this.$query.sorts = args;

        return this;
    }

    page(value) {
        if (!Number.isInteger(value)) {
            throw new Error('The VALUE must be an integer on page() method.');
        }

        this.$query.page = value;

        return this;
    }

    limit(value) {
        if (!Number.isInteger(value)) {
            throw new Error('The VALUE must be an integer on limit() method.');
        }

        this.$query.perPage = value;

        return this;
    }

    params(payload) {
        if (payload === undefined || payload.constructor !== Object) {
            throw new Error('You must pass a payload/object as param.');
        }

        _.assign(this.$query, payload);

        return this;
    }

    get(baseUrl) {
        return this.$query.get(baseUrl);
    }

    post(baseUrl, data = {}) {
        return this.$query.post(baseUrl, data);
    }

    put(baseUrl, data = {}) {
        return this.$query.put(baseUrl, data);
    }

    delete(baseUrl) {
        return this.$query.delete(baseUrl);
    }
}
